import { createContext, useContext, ReactNode } from "react";
import { useUI } from "../hooks";
import Notifications from '../components/Notifications';

interface Modal {
  id: string;
  component: ReactNode;
  props?: Record<string, unknown>;
}

interface UIContextValue {
  // Modals
  activeModals: Modal[];
  showModal: (
    id: string,
    component: ReactNode,
    props?: Record<string, unknown>,
  ) => void;
  hideModal: (id: string) => void;
  hideAllModals: () => void;

  // Theme
  isDarkMode: boolean;
  toggleDarkMode: () => void;

  // Documentation Panel
  isDocumentationPanelOpen: boolean;
  documentationPanelUrl?: string;
  toggleDocumentationPanel: () => void;
  openDocumentationPanel: (url?: string) => void;
}

const UIContext = createContext<UIContextValue | null>(null);

interface UIProviderProps {
  children: ReactNode;
}

export function UIProvider({ children }: UIProviderProps) {
  const ui = useUI();

  return (
    <UIContext.Provider value={ui}>
<div className={ui.isDarkMode ? "dark" : ""}>
        {/* Modals */}
        {ui.activeModals.map((modal) => (
          <div
            key={modal.id}
            className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full mx-4">
              {modal.component}
            </div>
          </div>
        ))}

        {/* Main Content */}
        {children}
<Notifications />
      </div>
    </UIContext.Provider>
  );
}

export function useUIContext() {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error("useUIContext must be used within a UIProvider");
  }
  return context;
}
